import React from "react";
import Nav from "react-bootstrap/Nav";
import { useHistory } from "react-router";

export default function ConveyorMenu() {
  const history = useHistory();

  return (
    <>
      <Nav.Item>
        <Nav.Link
          eventKey="/home"
          onClick={(e) => {
            history.push("EditHistoryReport");
          }}
        >
          แก้ไขข้อมูล
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          eventKey="/home"
          onClick={(e) => {
            history.push("SortingHistoryReport");
          }}
        >
          Sorting history Report
        </Nav.Link>
      </Nav.Item>

    </>
  );
}
